<template>
  <div class="container position-relative">
    <table class="table table-overview table-bordered">
      <tbody>
        <tr>
          <td>Non-PVC:</td>
          <td>
            <span
              :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
            >{{ nonPvcPercentage }}%</span>
            (
            <span title="Virgin &amp; additives">{{composition.additives_percentage}}</span>/
            <span title="Other Percentage">{{composition.other_percentage}}</span>)
          </td>
        </tr>
        <tr>
          <td>PVC</td>
          <td>
            <span
              :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
            >{{ pvcPercentage }}%</span>
          </td>
        </tr>
        <tr>
          <td class="table-separator-small">Other</td>
          <td class="table-separator-small">
            <span
              :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
            >{{ otherPercentage }}%</span>
          </td>
        </tr>
        <tr>
          <td>Total</td>
          <td>
            <span
              :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
            >{{ totalPercentage }}%</span>
          </td>
        </tr>
        <tr>
          <td class="table-separator-big" title="Recycled content">
            Recycled
            <br />content:
          </td>
          <td class="table-separator-big data-width">{{ recycledContent }}%</td>
        </tr>
      </tbody>
    </table>


    <form name="test" style="margin: 0 auto;" @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-7">
          <div class="row mt-5 mb-2">
            <div class="col-sm-4">
              <h5>PVC</h5>
            </div>
            <div class="col-sm-4">
              <h5
                :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
              >{{ pvcPercentage }}%</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <pvc-tree :input="false" :data="pvc" :totalPercentage="totalPercentage"></pvc-tree>
        </div>
      </div>

      <div class="row mt-5 mb-2">
        <div class="col-sm-4">
          <h5>Non-PVC</h5>
        </div>
        <div class="col-sm-4">
          <h5
            :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
          >{{ nonPvcPercentage }}%</h5>
        </div>
      </div>
      <div class="row base-control base-text form-group">
        <label class="col-sm-4 col-form-label">Virgin &amp; additives</label>
        <div class="col-sm-8 d-flex align-items-center">
          <div style="width: 80px;" class="mr-3">
            <input
              :disabled="isDisabled"
              class="form-control simple text-right"
              v-input-mask
              data-inputmask-mask="9{1,3}%"
              v-model="additives_percentage"
            />
          </div>
          <div class="flex-grow-1">
            <vue-slider
              ref="additives_percentage"
              :disabled="isDisabled"
              v-model="composition.additives_percentage"
              @change="setCorrectCompositionMaxPosiblePercent('additives_percentage')"
              @drag-end="onDragEnd('additives_percentage')"
            ></vue-slider>
          </div>
        </div>
      </div>

      <div class="row base-control base-text form-group">
        <label class="col-sm-4 col-form-label">Other materials</label>
        <div class="col-sm-8 d-flex align-items-center">
          <div style="width: 80px;" class="mr-3">
            <input
              :disabled="isDisabled"
              class="form-control simple text-right"
              v-input-mask
              data-inputmask-mask="9{1,3}%"
              v-model="other_percentage"
            />
          </div>
          <div class="flex-grow-1">
            <vue-slider
              ref="other_percentage"
              :disabled="isDisabled"
              v-model="composition.other_percentage"
              @change="setCorrectCompositionMaxPosiblePercent('other_percentage')"
              @drag-end="onDragEnd('other_percentage')"
            ></vue-slider>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="row mt-5 mb-2">
            <div class="col-sm-2">
              <h5>
                Other &nbsp;
                <a
                  href="javascript:;"
                  class="color-blue"
                  @click="addOther"
                  v-if="!isDisabled"
                >
                  <i class="fa fa-plus"></i>
                </a>
              </h5>
            </div>
            <div class="col-sm-10">
              <h5
                :class="{'color-blue': !areValuesOk, 'color-green': areValuesOk}"
              >{{ otherPercentage }}% Material from another Recovinyl recycler</h5>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="base-control pvc-tree">
            <pvc-list-item
              :value="data"
              v-for="data in pvcOther"
              :key="data.id"
              :options="compositions"
              :totalPercentage="totalPercentage"
              :showPiPcDivision="false"
            ></pvc-list-item>
          </div>
        </div>
      </div>
      <base-progress label="Recycled content" ref="recycledContent" v-model="recycledContent"></base-progress>

      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button radius="bl" component-class="blue" @click.native="$router.go(-1)">
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button radius="br" component-class="green filled" type="submit">
            Submit &amp; Go Next
            <i class="fas fa-arrow-right ml-3"></i>
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import BaseButton from '@/components/inputs/button/BaseButton';
import BaseProgress from '@/components/inputs/progress/BaseProgress';

import PvcTree from '@/components/inputs/tree/PvcTree';
import PvcListItem from '@/components/inputs/list/PvcListItem';

import stepValidators from '../StepValidators';

export default {
  data() {
    return {
      formScope: 'composition-s-1'
    };
  },

  computed: {
    ...mapState({
      baseData: state => state.submitWaste.baseData,
      outputSecondData: state => state.submitWaste.outputSecondData,
    }),
    ...mapGetters({
      currentCompositionData: 'userCompositions/currentCompositionData',
    }),
    getUserCompanies() {
      return this.$store.state.userCompanies.loggedUserCompanies;
    },
    isDisabled() {
      return !!this.composition.id;
    },
    pvc() {
      return this.$store.getters['materials/materials'];
    },
    pvcOther() {
      const out = [];
      const t = this.$store.getters['userCompositions/current'].materials;
      t.forEach(e => {
        if (
          typeof e.sub_composition_id !== 'undefined' &&
          (e.sub_composition_id || e.sub_composition_id === false)
        ) {
          out.push(e);
        }
      });
      return out;
    },
    recycledContent() {
      return this.pvcPercentage + this.otherPercentage;
    },
    totalPercentage() {
      return this.nonPvcPercentage + this.pvcPercentage + this.otherPercentage;
    },
    areValuesOk() {
      return this.totalPercentage === 100;
    },
    nonPvcPercentage() {
      return (
        this.composition.additives_percentage +
        this.composition.other_percentage
      );
    },
    pvcPercentage() {
      const composition = this.composition;

      function getCompositionMaterial(materialId) {
        let ret = null;
        composition.materials.forEach(e => {
          if (e.material_id === materialId) {
            ret = e;
          }
        });
        return ret;
      }

      function traverseTree(tree) {
        let ret = 0;
        tree.forEach(element => {
          const values = getCompositionMaterial(element.id);
          if (
            values &&
            typeof values.checked !== 'undefined' &&
            values.checked
          ) {
            ret += values.percentage;
          }
          if (
            typeof element.children !== 'undefined' &&
            element.children.length > 0
          ) {
            ret += traverseTree(element.children);
          }
        });
        return ret;
      }

      return traverseTree(this.pvc);
    },
    otherPercentage() {
      let percentage = 0;
      this.pvcOther.forEach(function(element) {
        if (
          typeof element.percentage !== 'undefined' &&
          typeof element.checked !== 'undefined' &&
          element.checked
        ) {
          percentage += element.percentage;
        }
      });
      return percentage;
    },
    additives_percentage: {
      get() {
        return this.composition.additives_percentage + '%';
      },
      set(value) {
        this.composition.additives_percentage = sanitizePercents(value);
        this.setCorrectCompositionMaxPosiblePercent('additives_percentage');
      }
    },
    other_percentage: {
      get() {
        return this.composition.other_percentage + '%';
      },
      set(value) {
        this.composition.other_percentage = sanitizePercents(value);
        this.setCorrectCompositionMaxPosiblePercent('other_percentage');
      }
    },
    userCompanies: {
      get() {
        return this.$store.getters['userCompanies/data'];
      },
      set(value) {
        this.$store.commit('userCompanies/data', value);
      }
    },
    getLoggedUserCompanies() {
      return {
        compositions: this.$store.state.userCompositions.data,
        companies: this.$store.state.userCompanies.loggedUserCompanies
      };
    },
    composition: {
      get() {
        return this.$store.getters['userCompositions/current'];
      },
      set(value) {
        this.$store.commit('userCompositions/current', value);
      }
    },
    compositions() {
      const c = [];

      // eslint-disable-next-line
      let compos = this.$store.getters['userCompositions/data'];
      compos.forEach(composition => {
        if (
          typeof composition.company_id !== 'undefined' &&
          this.composition.company &&
          composition.company_id !== this.composition.company.id
        ) {
          return;
        }
        c.push({
          id: composition.id,
          label: composition.name
        });
      });

      return c;
    }
  },

  watch: {
    /**
     * Set user last added composition branch
     */
    getLoggedUserCompanies(newValue) {
      const { companies, compositions } = newValue;
      if (!this.isDisabled && compositions.length && companies.length) {
        const lastComposition = compositions[compositions.length - 1];
        const lastCompositionAddedCompany = companies.filter(
          company => company.id === lastComposition.company_id
        )[0];
        this.composition.company = lastCompositionAddedCompany;
      }
    },
    'composition.company': function() {
      this.getCompanyCompositions(this.composition.company.id);
    }
  },

  methods: {
    ...mapActions({
      getUserCompaniesArray: 'userCompanies/getCompanies',
      getCompanyCompositions: 'userCompositions/companyCompositions',
      getMaterials: 'materials/materials',
      getCompositions: 'userCompositions/getCompositions'
    }),
    onDragEnd(name) {
      this.$refs[name].setValue(this.composition[name]);
    },
    setCorrectCompositionMaxPosiblePercent(name) {
      setTimeout(() => {
        if (this.totalPercentage > 100) {
          const newValue =
            sanitizePercents(this[name]) - (this.totalPercentage - 100);
          this.composition[name] = newValue;
        }
      }, 0);
    },
    addOther() {
      this.$store.dispatch('userCompositions/addOther');
    },
    onSubmit() {
      this.$validator.validateAll(this.formScope).then((result) => {
        if (this.areValuesOk) {
          if (result) {
            this.$store.commit('submitWaste/setStepsValidation', {
              stepId: 3,
              isValid: true,
            });

            const recycled_content = this.recycledContent;
            const { additives_percentage, other_percentage, materials } = this.currentCompositionData;
            this.$store.commit('submitWaste/setOutputSecondData', {
              recycled_content,
              additives_percentage,
              other_percentage,
              materials,
            });
            this.$router.push({ name: 'submit-waste-output-overview' });
          }
          // if (result) {
          //   this.$store.dispatch('userCompositions/save').then(() => {
          //     this.$snotify.success('Composition saved.');
          //     this.$router.go(-1);
          //   });
          // }
        } else {
          this.$snotify.error(
            'Non PVC + PVC + Other compositions sum needs to be 100%.'
          );
        }
      });
    },
    recalculateSliders() {
      const nonPvc = this.composition.additives_percentage + this.composition.other_percentage;
      this.composition.recycled_content = nonPvc;
    }
  },

  mounted() {
    const { company } = this.baseData;
    this.$store.commit('userCompositions/setCurrentCompositionCompany', company);

    this.recalculateSliders();
    this.getMaterials();
    this.getUserCompaniesArray(this.$store.getters['user/getLoggedInUserId']);
    this.getCompositions();
    stepValidators.register(2, async () => {
      const isFormValid = await this.$validator.validateAll(this.formScope);
      return isFormValid;
    });
    stepValidators.register(3, async () => {
      const isFormValid = await this.$validator.validateAll(this.formScope);
      return isFormValid;
    });
  },

  components: {
    BaseButton,
    BaseProgress,
    PvcTree,
    PvcListItem
  }
};
</script>
